import { createFileRoute, redirect, Outlet } from "@tanstack/react-router"
import { supabase } from "@/lib/supabase"
import { getUserFlags, getUserProgress } from "@/lib/api/user"
import { ApiError } from "@/lib/api"
import { posthog } from "@/lib/posthog"

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ location }) => {
    const { data } = await supabase.auth.getSession()
    if (!data.session) throw redirect({ to: "/auth/signin" })

    posthog.identify(data.session.user.id)

    let flags
    let progress
    try {
      ;[flags, progress] = await Promise.all([
        getUserFlags(),
        getUserProgress(),
      ])
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        await supabase.auth.signOut()
        throw redirect({ to: "/auth/signin" })
      }
      throw err
    }

    const requiresProgress =
      location.pathname === "/settings" ||
      location.pathname === "/stories" ||
      location.pathname.startsWith("/stories/")
    if (requiresProgress && progress === null) {
      throw redirect({ to: "/welcome" })
    }
    if (location.pathname === "/welcome" && progress !== null) {
      throw redirect({ to: "/stories" })
    }

    return { userFlags: flags, userProgress: progress }
  },
  component: () => <Outlet />,
})
